import { render, staticRenderFns } from "./EditSex.vue?vue&type=template&id=38b1ba50&"
import script from "./EditSex.vue?vue&type=script&lang=js&"
export * from "./EditSex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports